import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import WebGLVector from 'ol/layer/WebGLVector';
import MapViewUtility from './map-view.utility';

export default class ExportUtility {
  /**
   * Exports features from a given WebGLVector or VectorLayer to a GeoJSON file.
   * @param vectorLayer The vector layer containing features to export.
   * @param fileName The name of the file to be downloaded.
   */
  static exportLayerToGeoJSON(vectorLayer: WebGLVector | VectorLayer, fileName: string): void {
    const features = vectorLayer.getSource().getFeatures();

    // geoJSON can only be ESPG:3587 (default map projection)
    const geojsonStr = new GeoJSON().writeFeatures(features, {
      featureProjection: MapViewUtility.getDefaultMapProjection()
    });

    this.downloadFile(geojsonStr, fileName);
  }

  /**
   * Exports features from multiple WebGLVector or VectorLayer to a single GeoJSON file.
   * @param layers The vector layers containing features to export.
   * @param fileName The name of the file to be downloaded.
   */
  static exportLayersToGeoJSON(layers: (WebGLVector | VectorLayer)[], fileName: string): void {
    const allFeatures = layers.reduce((features, layer) => {
      return features.concat(layer.getSource().getFeatures());
    }, []);

    const geojsonStr = new GeoJSON().writeFeatures(allFeatures, {
      featureProjection: MapViewUtility.getDefaultMapProjection()
    });

    this.downloadFile(geojsonStr, fileName);
  }

  private static downloadFile(geojsonStr: string, fileName: string) {
    const blob = new Blob([geojsonStr], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    // create a temp dom element to trigger download of the geojsonStr
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    // clean-up
    URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
}
